import { useCallback, useEffect, useRef } from 'react';
import { useRcPortalWindowContext } from '../../../../foundation';
import { useSizeWithElRef } from './useSize';
export default function useWindowViewportRectRef(callback, customScrollParent) {
    var viewportInfo = useRef(null);
    var _a = useRcPortalWindowContext().externalWindow, externalWindow = _a === void 0 ? window : _a;
    var calculateInfo = useCallback(function (element) {
        if (element === null) {
            return;
        }
        var rect = element.getBoundingClientRect();
        var visibleWidth = rect.width;
        // eslint-disable-next-line one-var
        var visibleHeight, offsetTop;
        if (customScrollParent) {
            var customScrollParentRect = customScrollParent.getBoundingClientRect();
            var deltaTop = rect.top - customScrollParentRect.top;
            visibleHeight = customScrollParentRect.height - Math.max(0, deltaTop);
            offsetTop = deltaTop + customScrollParent.scrollTop;
        }
        else {
            visibleHeight = externalWindow.innerHeight - Math.max(0, rect.top);
            offsetTop = rect.top + externalWindow.pageYOffset;
        }
        viewportInfo.current = {
            offsetTop: offsetTop,
            visibleHeight: visibleHeight,
            visibleWidth: visibleWidth,
        };
        callback(viewportInfo.current);
    }, [callback, customScrollParent, externalWindow]);
    var _b = useSizeWithElRef(calculateInfo), callbackRef = _b.callbackRef, ref = _b.ref;
    var scrollAndResizeEventHandler = useCallback(function () {
        calculateInfo(ref.current);
    }, [calculateInfo, ref]);
    useEffect(function () {
        if (customScrollParent) {
            customScrollParent.addEventListener('scroll', scrollAndResizeEventHandler);
            var observer_1 = new externalWindow['ResizeObserver'](scrollAndResizeEventHandler);
            observer_1.observe(customScrollParent);
            return function () {
                customScrollParent.removeEventListener('scroll', scrollAndResizeEventHandler);
                observer_1.unobserve(customScrollParent);
            };
        }
        externalWindow.addEventListener('scroll', scrollAndResizeEventHandler);
        externalWindow.addEventListener('resize', scrollAndResizeEventHandler);
        return function () {
            externalWindow.removeEventListener('scroll', scrollAndResizeEventHandler);
            externalWindow.removeEventListener('resize', scrollAndResizeEventHandler);
        };
    }, [scrollAndResizeEventHandler, customScrollParent, externalWindow]);
    return callbackRef;
}
